import { render } from "./SDSTable.vue?vue&type=template&id=429d9b7f"
import script from "./SDSTable.vue?vue&type=script&lang=js"
export * from "./SDSTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__